import axios from '@/utils/request'
import config from '@/config/index'
//图片上传
export const upload = (data)=>{
  return axios.request({
     url: 'upload/alone',
     method: 'post',
     data
   })
};

//获取省市区
export const getArea = (data)=>{
  return axios.request({
    url: config.oss[process.env.VUE_APP_type]+'area.json',
    method: 'get',
    data
  })
};
//获取地图JSON
export const getJson = (params)=>{
  return axios.request({
    url:  config.oss[process.env.VUE_APP_type]+'/newMapJson/'+params.id+'.geoJson',
    method: 'get',
    params
  })
};
//客户-相关注册及登录地址
export const getClientsite = (params)=>{
  return axios.request({
    url:  'v1/clientsite/index',
    method: 'get',
    params
  })
};

// 导出订单
export const orderExport = (params)=>{
  return axios.request({
    url:  'v1/order/export',
    method: 'get',
    params
  })
};
// 网页链接列表
export const getWebUrl = (params)=>{
  return axios.request({
    url:  'v1/website/index',
    method: 'get',
    params
  })
};

// 网页链接详情
export const getWebUrlDetail = (params)=>{
  return axios.request({
    url:  'v1/website/detail',
    method: 'get',
    params
  })
};

// 权限-菜单
export const getMenu = (params)=>{
  return axios.request({
    url:  'v1/menu',
    method: 'get',
    params
  })
};